import { render, staticRenderFns } from "./TransferForm.vue?vue&type=template&id=cf714eea&scoped=true&"
import script from "./TransferForm.vue?vue&type=script&lang=ts&"
export * from "./TransferForm.vue?vue&type=script&lang=ts&"
import style0 from "./TransferForm.vue?vue&type=style&index=0&id=cf714eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf714eea",
  null
  
)

export default component.exports